import { render, staticRenderFns } from "./PowerSelection.vue?vue&type=template&id=0596d682&"
import script from "./PowerSelection.vue?vue&type=script&lang=js&"
export * from "./PowerSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports